import { useTranslation } from 'react-i18next';
import { Box, Divider, Typography } from '@mui/material';

import ContentContainer from '~/components/atoms/content-container/ContentContainer';
import { isMobileResolution } from '~/utils/common';

import BillingInformation from '../../Settings/components/BillingInformation';

function PaymentContainer() {
  const { t } = useTranslation();
  return (
    <ContentContainer
      display="flex"
      justifyContent="space-between"
      title={'Payment'}
      containerStyles={{ margin: '0 12px 24px 0', flex: 1 }}
    >
      <Box display="flex" flexDirection="column" flex={1} m={2}>
        <Box display="flex" alignItems="flex-start" flexDirection={isMobileResolution ? 'column' : 'row'} flex={1}>
          <Typography fontSize={20} flex={0.4}>
            1. {t('checkout:step1')}
          </Typography>
          <Box display="flex" alignItems="center" justifyContent="center" sx={{ flex: 1 }}>
            <BillingInformation isPayment />
          </Box>
        </Box>
        <Divider />
        <Box mt={2} flexDirection={isMobileResolution ? 'column' : 'row'}>
          <Typography fontSize={20} flex={0.4}>
            2. {t('checkout:step2')}
          </Typography>
        </Box>
      </Box>
    </ContentContainer>
  );
}

export default PaymentContainer;
